import { render, staticRenderFns } from "./FAQReadError.vue?vue&type=template&id=45aa387a&scoped=true"
import script from "./FAQReadError.vue?vue&type=script&lang=js"
export * from "./FAQReadError.vue?vue&type=script&lang=js"
import style0 from "./FAQReadError.vue?vue&type=style&index=0&id=45aa387a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45aa387a",
  null
  
)

export default component.exports